import { axiosPost } from '../ServiceBase.js';

export const buscarAportes = async (data) => {
  const aportes = await axiosPost('/v1/busquedas/buscarAportes', data);
  return aportes;
};
